import React from 'react';

// Define TypeScript interface for Props
interface ResultProps {
    count: number;
}

const Result: React.FC<ResultProps> = ({ count }) => {
    const renderText = () => {
        if (count > 1) {
            return (
                <>
                    <b>{count}</b>
                    {Drupal.t(' formations pour vos critères de recherche')}
                </>
            );
        } else if (count === 1) {
            return (
                <>
                    <b>{count}</b>
                    {Drupal.t(' formation pour vos critères de recherche')}
                </>
            );
        } else {
            return Drupal.t('Aucune formation pour vos critères de recherche');
        }
    };

    return (
        <div className={'result__wrapper'}>
            <div>{renderText()}</div>
        </div>
    );
};

export default Result;
